import React from 'react';
import { Icon } from './Icon';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: string;
  variant?: 'ghost' | 'surface' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  filled?: boolean;
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className = '', icon, variant = 'ghost', size = 'md', filled = false, ...props }, ref) => {
    const baseStyles =
      'aspectly:inline-flex aspectly:items-center aspectly:justify-center aspectly:rounded-lg aspectly:transition-colors aspectly:cursor-pointer aspectly:disabled:opacity-50 aspectly:disabled:pointer-events-none';

    const variants = {
      ghost: 'aspectly:text-on-surface-variant aspectly:hover:bg-primary-container',
      surface: 'aspectly:bg-surface-container-low aspectly:hover:bg-surface-container-lowest aspectly:hover:shadow-xs aspectly:text-on-surface-variant aspectly:hover:text-on-surface',
      outline: 'aspectly:border aspectly:border-outline-variant/30 aspectly:text-on-surface-variant aspectly:hover:bg-primary/5 aspectly:hover:text-primary aspectly:rounded-full',
    };

    const sizes = {
      sm: 'aspectly:p-1.5',
      md: 'aspectly:p-2',
      lg: 'aspectly:w-8 aspectly:h-8',
    };

    const iconSizes = {
      sm: 'aspectly:text-lg',
      md: '',
      lg: 'aspectly:text-lg',
    };

    return (
      <button
        ref={ref}
        className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
        {...props}
      >
        <Icon name={icon} filled={filled} className={iconSizes[size]} />
      </button>
    );
  },
);
IconButton.displayName = 'IconButton';
